var React = require('react');

function IconWordSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M137.9 74.2l-.5 875.3c0 5.5 4.5 10 10 10h729.4c5.5 0 10-4.5 10-10.1l-3.6-600.3c0-2.6-1.1-5.2-2.9-7l-275.1-275c-1.9-1.9-4.4-2.9-7.1-2.9H147.9c-5.5 0-10 4.5-10 10zm108.6 665.6v-73.6c0-5.5 4.5-10 10-10h511.8c5.5 0 10 4.5 10 10v73.6c0 5.5-4.5 10-10 10H256.5c-5.5 0-10-4.5-10-10zm531.8-177.2H256.5c-5.5 0-10-4.5-10-10V479c0-5.5 4.5-10 10-10h511.8c5.5 0 10 4.5 10 10v83.6zm-207.1-443l257.5 257.5H571.2V119.6z"}));
}

IconWordSolid.displayName = "IconWordSolid";

IconWordSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconWordSolid;

IconWordSolid.default = IconWordSolid;
